module.exports = __webpack_public_path__ + "static/img/2.78cd2862.png";